import React, { Component } from 'react'
import './ExitGroup.css'
import { BtnPrimary, BtnSecondary } from '../commons/Buttons'
import { database, ref, set } from '../../firebase'
import Loading from '../commons/Loading'
import { withRouter } from '../../withRouter'

class ExitGroup extends Component {
  constructor (props) {
    super(props)
    this.state = {
      activity: null
    }
    this.onSubmit = this.onSubmit.bind(this)
  }
  onSubmit () {
    this.setState({
      activity: true
    })
    this.exitGroup()
      .then(() => {
        this.setState({
          activity: null
        })
        this.props.history.push('/')
        this.props.closeModal()
      })
      .catch((err) => {
        console.error(err)
      })
  }
  exitGroup () {
    return new Promise((resolve, reject) => {
      set(ref(database, 'grupos/miembros/' + this.props.groupId + '/' + this.props.userId), null)
        .then(() => {
          return set(ref(database, 'usuarios/grupos/' + this.props.userId + '/' + this.props.groupId), null)
        })
        .then(() => {
          return set(ref(database, 'grupos/puntaje/' + this.props.groupId + '/global/' + this.props.userId), null)
        })
        .then(() => resolve())
        .catch((err) => reject(err))
    })
  }
  render () {
    return (
      <div className='exit-group'>
        <h2>¿Seguro que deseas salir del grupo?</h2>
        <p>¡No hay vuelta atrás!, si deseas abandonar el terreno de juego tus resultados y quinielas serán eliminadas. ¿Vas a dejar que alguien más se lleve el triunfo?</p>
        <div className='exit-group__row'>
          <div className='exit-group__col'>
            <BtnSecondary onClick={() => this.props.closeModal()}>¡Claro que no!</BtnSecondary>
          </div>
          <div className='exit-group__col'>
            <BtnPrimary onClick={() => this.onSubmit()} disabled={this.state.activity}>{this.state.activity ? <Loading /> : 'Sí, abandonar'}</BtnPrimary>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(ExitGroup)
